import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

class SmsAdd extends React.Component {
  render() {
    return (
        <>
          <div className="sectionform pt-4">
            <div className="container form-cont">  
              <div className="row">
                <div className="col-md-12">       
                  <h2>SMS Template</h2>
                </div>
              </div>  
              <Form className="row row-cols-3 lead-form pt-5">
                    <div className="col-md-6">
                      <div className="form-group">
                          <input placeholder="Name" type="text" className="mr-sm-2 form-control" />
                        </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="promotional" value="promotional " />
                            <label class="form-check-label" for="promotional ">Promotional </label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="transactional " value="transactional " />
                            <label class="form-check-label" for="transactional ">Transactional </label>
                          </div>
                          </div>
                    </div>

                    

                    <div className="col-md-6 pt-3">
                      <div className="form-group">
                          <textarea placeholder="Message" type="text" className="mr-sm-2 form-control"></textarea>
                        </div>
                    </div>

                  <div className="col-md-12 text-center btnsend pt-4">
                    <Button variant="success">Save</Button>
                  </div>
              </Form>
            </div>
          </div>
      </>
    );
  }
}
export default SmsAdd;
